<template>
  <div
    class="col-md-5 px-3 product-order-1 filter-section-top-menu"
    :class="{ 'section-hidden' : isSectionHidden }"
  >
    <header class="header-section mb-1">
      <h2 class="middle-header-text text-center me-2 d-inline-block">
        Filter Search
      </h2>
    </header>

    <div class="row ps-2 constraint-max-height">
      <div class="col-3 px-2">
        <!-- <label-checkbox @change="getCheckbox" :category="brandDepartmentSeasons" /> -->
        <div
          class="pb-12"
        >
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Brands
            </h6>
          </span>
          <template v-for="brand in filtersData?.brand">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'brand-'+brand.id"
                v-model="params.brand"
                type="checkbox"
                class="form-check-input"
                :value="brand.id"
              >
              <label
                :for="'brand-'+brand.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ brand.name }}
              </label>
            </div>
            <div
              v-if="brand.sub_brands.length > 0"
              class="pl-10"
            >
              <div
                v-for="subBrand in brand.sub_brands"
                class="p-checkbox form-check d-flex align-items-center"
              >
                <input
                  :id="'subBrand-'+subBrand.id"
                  v-model="params.sub_brand"
                  type="checkbox"
                  class="form-check-input"
                  :value="subBrand.id"
                >
                <label
                  :for="'subBrand-'+subBrand.id"
                  class="form-check-label ms-2 mt-1"
                >
                  {{ subBrand.name }}
                </label>
              </div>
            </div>
          </template>
        </div>

        <div>
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Departments
            </h6>
          </span>
          <template v-for="department in filtersData?.department">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'department-'+department.id"
                v-model="params.department"
                type="checkbox"
                class="form-check-input"
                :value="department.id"
              >
              <label
                :for="'department-'+department.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ department.name }}
              </label>
            </div>
          </template>
        </div>
        <div>
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Season
            </h6>
          </span>
          <template v-for="season in filtersData?.season">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'season-'+season.id"
                v-model="params.season"
                type="checkbox"
                class="form-check-input"
                :value="season.id"
              >
              <label
                :for="'season-'+season.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ season.name }}
              </label>
            </div>
          </template>
        </div>
      </div>
      <div class="col-3 px-2">
        <div
          class="pb-12"
        >
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Categories
            </h6>
          </span>
          <template v-for="category in filtersData?.category">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'category-'+category.id"
                v-model="params.category"
                type="checkbox"
                class="form-check-input"
                :value="category.id"
              >
              <label
                :for="'category-'+category.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ category.name }}
              </label>
            </div>
          </template>
        </div>
        <div
          class="pb-12"
        >
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Size
            </h6>
          </span>
          <template v-for="size in filtersData?.size">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'size-'+size.id"
                v-model="params.size"
                type="checkbox"
                class="form-check-input"
                :value="size.id"
              >
              <label
                :for="'size-'+size.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ size.name }}
              </label>
            </div>
          </template>
        </div>
        <!-- <label-checkbox @change="getCheckbox" :category="category" /> -->
      </div>
      <div class="col-3 px-2">
        <div
          class="pb-12"
        >
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Colors
            </h6>
          </span>
          <template v-for="color in filtersData?.color">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'color-'+color.id"
                v-model="params.color"
                type="checkbox"
                class="form-check-input"
                :value="color.id"
              >
              <label
                :for="'color-'+color.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ color.name }}
              </label>
            </div>
          </template>
        </div>
        <!-- <label-checkbox @change="getCheckbox" :category="category" /> -->
      </div>
      <div class="col-3 px-2">
        <div
          class="pb-12"
        >
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Patterns
            </h6>
          </span>
          <template v-for="pattern in filtersData?.pattern">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'pattern-'+pattern.id"
                v-model="params.pattern"
                type="checkbox"
                class="form-check-input"
                :value="pattern.id"
              >
              <label
                :for="'pattern-'+pattern.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ pattern.name }}
              </label>
            </div>
          </template>
        </div>
        <div>
          <span class="checkbox-children me-2 bold d-flex align-items-center">
            <h6 class="sub-title text-uppercase text-start mb-9">
              Availability
            </h6>
          </span>
          <template v-for="availability in filtersData?.availability">
            <div
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'availability-'+availability.id"
                v-model="params.availability"
                type="checkbox"
                class="form-check-input"
                :value="availability.id"
              >
              <label
                :for="'availability-'+availability.id"
                class="form-check-label ms-2 mt-1"
              >
                {{ availability.name }}
              </label>
            </div>
          </template>
        </div>
        <!-- <label-checkbox @change="getCheckbox" :category="availabilities" /> -->
        <div class="mb-3">
          <inventory-criteria-quantity-input
            :quantity="params.quantity ? params.quantity.toString() : ''"
            :criteria="params.criteria"
            @inventoryDropdownChange="onIcqiInventoryDropdownChange"
            @inventoryInputBlurred="onIcqiInventoryInputBlurred"
          />
          <!-- <inventory-criteria-quantity-input /> -->
        </div>
      </div>
    </div>
    <div class="row">
      <apply-button
        @apply="onEventApplyClicked"
        @toggleSection="onToggleSectionClicked"
      />
    </div>
  </div>
</template>

<script>
import InventoryCriteriaQuantityInput from '~/components/common/InventoryCriteriaQuantityInput'
import ApplyButton from '~/components/common/TopMenu/ApplyButton'
import { mapActions } from 'vuex'
import componentHelpers from '~/mixins/componentHelpers'
import productFilterParams from '~/mixins/productFilterParams'

export default {
  name: 'FilterSection',
  components: { InventoryCriteriaQuantityInput, ApplyButton },
  mixins: [componentHelpers, productFilterParams],
  props: {
    isSectionHidden: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedAvailabilityBox: {},
      selectedCategoryBox: {},
      selectedCheckBox: {}
    }
  },
  methods: {
    ...mapActions({
      setSelectedChildrenCheckBox: 'menus/setSelectedChildrenCheckBox',
      searchFilterCheck: 'menus/searchFilterCheck'
    }),
    onEventApplyClicked () {
      this.applyFilters()
    },
    onToggleSectionClicked (e) {
      this.$emit('toggleSection', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-section-top-menu {
  position: relative;
  padding-right: 0.5rem !important;
  .constraint-max-height {
    height: calc(100% - 100px);
    .col-3 {
      height: calc(100% - 10px);
      overflow: hidden;
      margin-bottom: 60px;
      .pb-12 {
        padding-bottom: 12px;
        max-height: 100%;
      }
    }
  }
  .checkbox-children {
    color: #898989;
  }

  .sub-title {
    height: 14px;
  }
  .pl-10 {
    padding-left: 10px;
  }
}
@media (max-width:1280px)  {
  .section-hidden {
    display: none;
  }
  .col-md-5 {
    width: 100%;
  }
  .product-order-1 {
    order: 1;
  }
}
.p-checkbox {
    margin-bottom: 15px;
    .form-check-input {
        width: 20px;
        height: 20px;
        min-width: 20px;
        border-radius: 0;
        border: 1px solid #383838;

        &:checked, &:indeterminate {
            background-color: #383838;
            border-color: #383838;
        }
    }

    .form-check-label {
        font: normal normal normal 14px/16px Arial;
        letter-spacing: 0;
        color: #898989;
        white-space: normal;
        text-align: left;
    }
    label, input {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
}
@media (max-width: 700px) {
  .col-md-5 {
    width: 50%;
  }
  .col-3 {
    height: auto !important;
    width: 100%;
  }
  .filter-section-top-menu {
     .constraint-max-height {
       .col-3:not(:last-of-type) {
        margin-bottom: 0px !important;
       }
       .col-3:last-of-type {
        margin-bottom: 100px !important;
       }
      }
    }
}
.mb-9 {
  margin-bottom: 9px !important;
}
</style>
